export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12100.b937415f.jpg";